import { useCallback } from 'react';

import { ConfluenceSiteAri } from '@atlassian/ari/confluence/site';
import { AIAnswerAPIType } from '@atlassian/search-ai';
import { sainStreamFetchConvoAIService } from '@atlassian/search-ai/stream-fetch';
import type { AIAnswerQueryFunctionType, SearchAIAnswerQueryVariables } from '@atlassian/search-ai';

import { useSessionData } from '@confluence/session-data/entry-points/useSessionData';

export type useAISearchSupplierArgs = {
	prequeryBannerEnabled?: boolean;
	dismissPrequeryBanner?: () => void;
	children?: React.ReactNode;
};

export type AISearchConfigType =
	| {
			aiSearchQueryFunction: AIAnswerQueryFunctionType;
			prequeryBannerEnabled?: boolean;
			dismissPrequeryBanner?: () => void;
			followUpsEnabled?: boolean;
	  }
	| undefined;

type AISearchSupplierType = {
	aiSearchConfig: AISearchConfigType;
};

export const useAISearchSupplier = ({
	prequeryBannerEnabled,
	dismissPrequeryBanner,
}: useAISearchSupplierArgs): AISearchSupplierType => {
	const { cloudId, isAdminHubAIEnabled } = useSessionData();

	const cloudIdARI = ConfluenceSiteAri.create({
		siteId: cloudId,
	}).toString();

	const aiSearchStreamingFunction = useCallback(
		({ variables }: { variables: Omit<SearchAIAnswerQueryVariables, 'cloudIdARI'> }) => ({
			type: AIAnswerAPIType.STREAM,
			stream: sainStreamFetchConvoAIService({
				variables: { ...variables, cloudIdARI },
				isReadingAids: false,
			}),
		}),
		[cloudIdARI],
	);

	return {
		aiSearchConfig: isAdminHubAIEnabled
			? {
					aiSearchQueryFunction: aiSearchStreamingFunction,
					prequeryBannerEnabled,
					dismissPrequeryBanner,
					followUpsEnabled: true,
				}
			: undefined,
	};
};
